(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _FlyerModal = _interopRequireDefault(require("./modules/FlyerModal"));

var _Debounce = _interopRequireDefault(require("./modules/Debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CCM = CCM || {};

CCM.FlyerFrontend = function ($) {
  var img = null;
  var ratio = 0;
  $(document).ready(function () {
    img = document.getElementById("clrflyr_img"); // Make sure that an image is present for the flyer. If there's no image there's no flyer.

    if (!img) {
      return;
    } // Ensure the image is loaded before we initialize things


    img.onload = function () {
      adjustClickables();
      initClickables();
    };

    img.src = $(img).attr("src");
    window.addEventListener("resize", (0, _Debounce["default"])(function () {
      adjustClickables();
    }, 300));
  });

  var initClickables = function initClickables() {
    $(".clrflyr_clickable_div").each(function (i, element) {
      new _FlyerModal["default"](element, {
        data_id: $(element).attr("data-id")
      });
    });
  };

  var adjustClickables = function adjustClickables() {
    ratio = $(img).width() / img.naturalWidth;
    $(".clrflyr_clickable_div").each(function (i, element) {
      var _this = $(this);

      _this.css("top", parseFloat(_this.attr("data-top")) * ratio);

      _this.css("left", parseFloat(_this.attr("data-left")) * ratio);

      _this.css("height", parseFloat(_this.attr("data-height")) * ratio);

      _this.css("width", parseFloat(_this.attr("data-width")) * ratio);

      _this.addClass("shown");
    });
  };
}(jQuery);

},{"./modules/Debounce":2,"./modules/FlyerModal":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = debounce;

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Modal2 = _interopRequireDefault(require("./Modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FlyerSelectModal = /*#__PURE__*/function (_Modal) {
  _inherits(FlyerSelectModal, _Modal);

  var _super = _createSuper(FlyerSelectModal);

  function FlyerSelectModal(trigger_selector) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, FlyerSelectModal);

    return _super.call(this, trigger_selector, args);
  }

  _createClass(FlyerSelectModal, [{
    key: "setData",
    value: function setData() {
      var content_div = jQuery(".clrflyr_modal_data[data-id='".concat(this.args.data_id, "']"));
      this.productSrc = content_div.attr("data-src");
      this.changeGallerySrc(content_div);
      this.setTitle(content_div.attr("data-title"));
      this.setContent(content_div.html());
    }
  }, {
    key: "changeGallerySrc",
    value: function changeGallerySrc(content_div) {
      content_div.find(".woocommerce-product-gallery__image a").attr("href", this.productSrc);
    }
  }, {
    key: "getFooterButtons",
    value: function getFooterButtons() {
      return "<div class=\"wp-core-ui clrflyr_spaced\">\n\t\t\t\t<button class=\"clrflyr_dialog-close-btn clrflyr_btn clrflyr_wp_secondary_btn\">Close</button>\n\t\t\t\t<a href=\"".concat(this.productSrc, "\" class=\"clrflyr_dialog-close-btn clrflyr_btn clrflyr_wp_primary_btn\">View Product</a>\n\t\t\t</div>");
    }
  }]);

  return FlyerSelectModal;
}(_Modal2["default"]);

exports["default"] = FlyerSelectModal;

},{"./Modal":5}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  ESC: 27,
  ENTER: 13,
  TAB: 9,
  BACKSPACE: 8
};
exports["default"] = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _KeyCodes = _interopRequireDefault(require("./KeyCodes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Modal = /*#__PURE__*/function () {
  function Modal(trigger_selector) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Modal);

    this.title = "";
    this.content = "";
    this.args = args;
    this.overlay_element = null;
    this.modal_element = null;
    this.trigger_selector = null;
    this.setData();
    this.createModal();
    this.listenEvents(trigger_selector);
  }

  _createClass(Modal, [{
    key: "setData",
    value: function setData() {} // Fill this in if we need to set any data within child classes

    /**
     * Set up listener events for modal
     *
     * @param mixed trigger_selector  Object or string which will open the modal.  If string, it should be a selector (Ex. ".class_name")
     */

  }, {
    key: "listenEvents",
    value: function listenEvents(trigger_selector) {
      var _this = this;

      // Opening the modal
      document.body.addEventListener("click", function (e) {
        _this.openModal(trigger_selector, e);
      });
      document.body.addEventListener("touch", function (e) {
        _this.openModal(trigger_selector, e);
      }); // Close modal using ESC

      window.addEventListener("keyup", function (e) {
        if (e.keyCode === _KeyCodes["default"].ESC) {
          _this.closeModal();
        }
      });
    }
  }, {
    key: "openModal",
    value: function openModal(trigger_selector, event) {
      var triggers = _typeof(trigger_selector) === "object" ? [trigger_selector] : _toConsumableArray(document.querySelectorAll(trigger_selector)); // If the target element was a trigger to open the modal

      var triggered_elements = triggers.filter(function (element) {
        return element === event.target || element.contains(event.target);
      }); // If modal trigger was clicked

      if (triggered_elements.length) {
        this.showModal(event);
      } // Close button or overlay clicked
      else if (!!event.target.closest(".clrflyr_dialog-close-btn") || event.target.classList.contains("clrflyr_modal_active")) {
          this.closeModal();
        }
    }
    /**
     * Create the modal overlay and the dialog
     */

  }, {
    key: "createModal",
    value: function createModal() {
      // Create overlay
      this.overlay_element = document.createElement("div");
      this.overlay_element.className = "clrflyr_modal";
      var footer_buttons = this.getFooterButtons(); // Add modal to the overlay

      var modal = "<div class=\"clrflyr_dialog-header\">".concat(this.title, "</div>\n            <div class=\"clrflyr_dialog-body\">\n                <div class=\"clrflyr_dialog-content\">").concat(this.content, "</div>\n            </div>\n            <div class=\"clrflyr_dialog-footer\">\n                ").concat(footer_buttons, "\n            </div>");
      this.modal_element = document.createElement("div");
      this.modal_element.className = "clrflyr_dialog clrflyr_dialog_product";
      this.modal_element.innerHTML = modal;
      this.overlay_element.appendChild(this.modal_element); // Append stuff to body

      document.body.appendChild(this.overlay_element);
    }
    /**
     * Show the modal via CSS class
     *
     */

  }, {
    key: "showModal",
    value: function showModal(e) {
      this.overlay_element.classList.add("clrflyr_modal_active");
      document.body.classList.add("clrflyr_no_scroll");
    }
    /**
     * Close modal via CSS class
     *
     */

  }, {
    key: "closeModal",
    value: function closeModal() {
      this.overlay_element.classList.remove("clrflyr_modal_active");
      document.body.classList.remove("clrflyr_no_scroll");
    }
    /**
     * Return footer button html
     * Note: Overwrite this in child classes to show different buttons in the footer
     */

  }, {
    key: "getFooterButtons",
    value: function getFooterButtons() {
      return '<button class="btn clrflyr_dialog-close-btn">Close</button>';
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this.title = title;
    }
  }, {
    key: "setContent",
    value: function setContent(content) {
      this.content = content;
    }
  }, {
    key: "setOpenAction",
    value: function setOpenAction(action) {
      this.open_action = action;
    }
  }, {
    key: "setCloseAction",
    value: function setCloseAction(action) {
      var always_close_modal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.close_action = action;
      this.always_close_modal = always_close_modal;
    }
  }]);

  return Modal;
}();

exports["default"] = Modal;

},{"./KeyCodes":4}]},{},[1]);
